import React from "react";
import { Link } from "react-router-dom";

export default function HotArticle({articles}) {
    return <>
        <div className="p-4 mb-6 bg-white shadow">
            <h4 className="mb-2 text-xl font-bold">Artikel Terbaru</h4>
            {articles.map((article) => (
                <div key={article.id_artikel} className="mb-3">
                    <Link
                        to={`/article/${article.encrypted_id}`}
                        className="text-blue-500 hover:underline"
                    >
                        {article.judul_artikel}
                    </Link>
                    <p className="text-sm text-gray-500">
                        <i className="mr-2 far fa-calendar"></i> {article.update_date.substring(0, 10)}
                    </p>
                </div>
            ))}
        </div>

    </>
}

